import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { InfoAndSingleActionComponentVarOne } from 'src/consumer/components/ListingPageComponentsAndHelpers/ListingPageComponents'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { PublicAppFooter } from 'src/consumer/components/PublicAppFooter'
import PublicAppHeader from 'src/consumer/components/PublicAppHeader'
import { ClubbedAuthModal } from 'src/consumer/components/SignIn/ClubbedAuthComponents'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { getDataWithoutParams } from 'src/consumer/services/featureServices'
import { getImageLink, isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'

export default function ClinicBrandLandingPage() {
  const navigate = useNavigate()
  const { clinicBrandSlug } = useParams()
  const [clinicBrandData, setClinicBrandData] = useState()
  const [dataLoading, setDataLoading] = useState(false)
  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')

  async function pageSetup() {
    setDataLoading(true)
    let response = await getDataWithoutParams(
      `/api/external/clinic/brand-and-clinics?slug=${clinicBrandSlug}`,
    )
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      setClinicBrandData(response?.data?.data)
      setDataLoading(false)
    } else {
      navigate('/404')
    }
  }

  useEffect(() => {
    pageSetup()
  }, [])

  return (
    <>
      {clinicBrandData && (
        <SEOComponent
          title={clinicBrandData?.clinicBrand?.brandName || 'AUMHUM'}
          description={clinicBrandData?.clinicBrand?.brandName || 'AUMHUM'}
          image={
            clinicBrandData?.clinicBrand?.brandImage &&
            getImageLink(clinicBrandData?.clinicBrand?.brandImage)
          }
        />
      )}
      {dataLoading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <>
          <PublicAppHeader
            loginFunction={() => {
              setTypeOfClubbedAuthModal('login')
              setShowClubbedAuthModal(true)
            }}
            registerFunction={() => {
              setTypeOfClubbedAuthModal('signup')
              setShowClubbedAuthModal(true)
            }}
            config={{ showLinks: false }}
          />
          <ClubbedAuthModal
            open={showClubbedAuthModal}
            onClose={() => {
              setShowClubbedAuthModal(false)
            }}
            loginVariant={typeOfClubbedAuthModal === 'login'}
          />
          <InfoAndSingleActionComponentVarOne
            headline={clinicBrandData?.clinicBrand?.brandName}
            description={''}
            image={
              clinicBrandData?.clinicBrand?.brandImage &&
              getImageLink(clinicBrandData?.clinicBrand?.brandImage)
            }
          />
          <div style={{ padding: '20px', width: '100%' }}>
            <div style={{ marginBottom: '20px', textAlign: 'center' }}>
              <b>Choose a Location: </b>
            </div>
            {(!clinicBrandData?.clinics || clinicBrandData?.clinics?.length === 0) && (
              <div style={{ textAlign: 'center', color: '#6a6a6a' }}>
                No locations are available yet. Please check back soon.
              </div>
            )}
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '20px',
                width: '100%',
                justifyContent: 'center',
              }}
            >
              {clinicBrandData?.clinics?.map((clinicItem, clinicItemIndex) => {
                return (
                  <div
                    key={clinicItemIndex}
                    style={{
                      width: '100%',
                      maxWidth: '400px',
                      border: '1px solid #c6c6c6',
                      borderRadius: '8px',
                      padding: '20px',
                      cursor: 'pointer',
                    }}
                    onClick={() => navigate(`${clinicItem?.slug}`, { state: clinicBrandData })}
                  >
                    <div>
                      <b>{clinicItem?.name}</b>
                    </div>
                    <div>{clinicItem?.description}</div>
                    <div
                      style={{
                        margin: '5px auto',
                        padding: '5px 10px',
                        background: '#6a6dd2',
                        color: '#FFF',
                        fontWeight: 500,
                        textAlign: 'center',
                        borderRadius: '8px',
                      }}
                    >
                      Choose
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <PublicAppFooter />
        </>
      )}
    </>
  )
}
